import { SET_IS_LOADING, SET_LIST_SERVICE } from '../constants/listService';

export const setListService = (payload) => ({
  type: SET_LIST_SERVICE,
  payload,
});

export const setIsLoading = (payload) => ({
  type: SET_IS_LOADING,
  payload,
});
